import M from 'materialize-css'

export default {
  notice(message) {
    M.toast({
      html: message,
      classes: 'light-green'
    })
  },

  error(message) {
    M.toast({
      html: message,
      classes: 'red darken-1'
    })
  }
}
